import { useAdminUpdate } from '@reapitform/hooks'
import { AdminFormPayload, AdminFormResponse } from '../types'

/**
 * Creates a form definition (`POST /api/forms`). The created form — including its server-assigned
 * `referenceID` — is returned in the response body. No success toast here: the create-form flow chains
 * into a version create and toasts once at the end.
 */
export const useCreateAdminForm = () =>
  useAdminUpdate<AdminFormPayload, AdminFormResponse>({
    path: '/api/forms',
    method: 'POST',
    errorMessage: 'Failed to create the form',
  })
